import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ab78642"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "faq-item" }
const _hoisted_2 = { class: "arrow-icon" }

import { IonIcon, IonText } from "@ionic/vue";
import { withDefaults } from "vue";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FaqItem',
  props: {
    question: {},
    answer: {}
  },
  setup(__props: any) {



const isOpened = ref<boolean>(false);

const handleOpen = () => {
	isOpened.value = !isOpened.value
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "faq-item__question",
      onClick: handleOpen
    }, [
      _createVNode(_unref(IonText), null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.question), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        (!isOpened.value)
          ? (_openBlock(), _createBlock(_unref(IonIcon), {
              key: 0,
              src: "assets/icon/arrow-down-light.svg"
            }))
          : _createCommentVNode("", true),
        (isOpened.value)
          ? (_openBlock(), _createBlock(_unref(IonIcon), {
              key: 1,
              src: "assets/icon/arrow-up-light.svg"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    (isOpened.value)
      ? (_openBlock(), _createBlock(_unref(IonText), {
          key: 0,
          class: "faq-item__answer"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.answer), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})